export default __webpack_public_path__ + "static/media/vision.8bedb2da.png";